/**
 * Transforms a given URI text by replacing spaces with hyphens and converting Swedish characters to their English equivalents.
 * 
 * @param {string} uriText - The URI text to transform.
 * @returns {string} The transformed URI text.
 */
export function uriTransformer(uriText) {
  const withoutSpaces = uriText.replace(/\s+/g, '-');
  const withoutSwedishLetters = withoutSpaces
    .toLowerCase()
    .replace(/[åä]/g, 'a')
    .replace(/ö/g, 'o');

  return withoutSwedishLetters;
}